import styles from "./WidgetButton.module.css";

const ButtonControl = (props) => {
    return (
        <div
            className={`${styles["save-button"]} settings-btn-dark`}
            onClick={props.onClick}
            tabIndex="0"
            style={props.cssStyle}
        >
            <div className={styles["save-button-content"]}>
                <span className={styles["save"]}>{props.text || "Save"}</span>
            </div>
        </div>
    );
}

export default ButtonControl;